/*
 * Copyright Evollis 2021
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of Evollis.
 * The intellectual and technical concepts contained herein are
 * proprietary to Evollis and are protected by trade secret and copyright law.
 * Dissemination of this information or reproduction of this material
 * is STRICTLY FORBIDDEN unless prior written permission is obtained
 * from Evollis.
 */
import DynamicFinalPageText from "../../components/atoms/DynamicFinalPageText/DynamicFinalPageText"
import IconSadFaceReject from "../../components/atoms/IconSadFaceReject"
import Footer from "../../components/main/Footer"
import { Topbar } from "../../components/organisms/Topbar"
import { TENANTS } from "../../constants"
import { initPdiComponent } from "../../core/service/BusinessLogicService"
import { isPdiRetailTenant, loc } from "../../core/utils"
import useGetScoreAMLAlertCodeByOpl from "./hooks/useGetScoreAMLAlertCodeByOpl"
import React, { useEffect } from "react"
import { Button, Col, Container, Row } from "react-bootstrap"

const MEDIAMARKT_TENANTS = [TENANTS.MEDIAMARKT_NL, TENANTS.MEDIAMARKT_BE]

function ScoreKOPage({ tunnelData, history }) {
  const { tenant, opl, shopUrl, pdiRetailUrl, isJourneyResumedAtHome } = tunnelData
  const { scoreAMLAlertCodes } = useGetScoreAMLAlertCodeByOpl(opl)
  const pleaseStudyOtherPaymentMeans = loc("please_study_other_payment_means")
  const isMediamarktTenant = MEDIAMARKT_TENANTS.includes(tenant)
  const orderCanceledMessage = isMediamarktTenant
    ? loc`Your order has been cancelled.`
    : loc`Your order is canceled. The amount of the upfront will not be deducted from you.`

  useEffect(() => {
    initPdiComponent("ScoreKoPage")
  }, [])

  return (
    <Container fluid>
      <Row noGutters>
        <Col className="misc-block">
          <Row>
            <Topbar tunnelData={tunnelData} displayToggleButton={false} history={history} />

            <Col sm={12}>
              {/* CONTENT */}
              <Container>
                <Row className="justify-content-center">
                  <Col xs={11} sm={10} md={10} lg={6} className="text-center misc-mono-block">
                    {tenant === TENANTS.BPLS ? (
                      <React.Fragment>
                        <IconSadFaceReject />
                        <h1>{loc(`bplsScoreKoTitle`)}</h1>
                        <p>{loc("bplsScoreKoSubtitle")}</p>
                        <p>{loc("bplsScoreKoText")}</p>
                        <Button href={shopUrl} variant="outline-primary" className="ico-back-small-before">
                          {loc`button_back_to_my_basket`}
                        </Button>
                      </React.Fragment>
                    ) : (
                      <>
                        <span className="ico-danger-background">
                          <i className="far fa-times"></i>
                        </span>
                        <h1>{loc`Request denied`}</h1>
                        {tenant === TENANTS.SAMSUNG_ES && scoreAMLAlertCodes ? (
                          <DynamicFinalPageText statusCode={scoreAMLAlertCodes} />
                        ) : (
                          <>
                            <p>
                              {loc`We regret to inform you that we cannot give a favorable response to your request.`}
                            </p>
                            <p>
                              <strong>{orderCanceledMessage}</strong>
                            </p>
                            {!isMediamarktTenant &&
                              pleaseStudyOtherPaymentMeans &&
                              pleaseStudyOtherPaymentMeans !== "N/A" && (
                                <p>
                                  <i>{pleaseStudyOtherPaymentMeans}</i>
                                </p>
                              )}
                          </>
                        )}
                        {!isJourneyResumedAtHome && (
                          <Button
                            href={isPdiRetailTenant(tenant) ? `${pdiRetailUrl}home` : shopUrl}
                            variant="outline-primary"
                            className="ico-back-small-before"
                          >
                            {loc`Back to shop`}
                          </Button>
                        )}
                      </>
                    )}
                  </Col>
                </Row>
              </Container>
              {/* END CONTENT */}
            </Col>
            <Col sm={12}>
              <Container>
                <Footer tunnelData={tunnelData} />
              </Container>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  )
}

export default ScoreKOPage
